import { HttpMethod, Performer } from './core'

export class ClaimReferral extends Performer<void, { balance: bigint }> {
  protected method = HttpMethod.POST
  protected url = '/claim-referral'
}
